import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* eslint-disable max-len */
import React from 'react';
export default function ExpandUpIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "44",
    height: "22",
    viewBox: "0 0 44 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M22 22C34.1503 22 44 12.1503 44 0H0C0 12.1503 9.84974 22 22 22Z",
      fill: "#F2F2F2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22 20C33.0457 20 42 11.0457 42 0H2C2 11.0457 10.9543 20 22 20Z",
      fill: "#134CD8"
    }), /*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M22.3886 6.09229L26.839 10.5427C27.0537 10.7574 27.0537 11.1053 26.839 11.32L26.32 11.839C26.1057 12.0533 25.7584 12.0537 25.5436 11.8399L22 8.3129L18.4564 11.8399C18.2416 12.0537 17.8943 12.0533 17.68 11.839L17.161 11.32C16.9463 11.1053 16.9463 10.7573 17.161 10.5427L21.6114 6.09229C21.826 5.87768 22.174 5.87768 22.3886 6.09229Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0",
        children: /*#__PURE__*/_jsx("rect", {
          x: "27",
          y: "14",
          width: "10",
          height: "10",
          transform: "rotate(180 27 14)",
          fill: "white"
        })
      })
    })]
  });
}